import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { ROLE_LABELS } from "@/lib/rbac";

const ROLE_STYLES = {
  super_admin: "bg-purple-100 text-purple-900 border-purple-300",
  management: "bg-amber-100 text-amber-900 border-amber-300",
  qa_manager: "bg-emerald-100 text-emerald-900 border-emerald-300",
  qa_executive: "bg-emerald-50 text-emerald-800 border-emerald-200",
  production_manager: "bg-orange-100 text-orange-900 border-orange-300",
  production_supervisor: "bg-orange-50 text-orange-800 border-orange-200",
  stores_manager: "bg-blue-100 text-blue-900 border-blue-300",
  store_executive: "bg-blue-50 text-blue-800 border-blue-200",
  purchase_manager: "bg-indigo-100 text-indigo-900 border-indigo-300",
  maintenance_manager: "bg-slate-200 text-slate-800 border-slate-300",
  maintenance_executive: "bg-slate-100 text-slate-700 border-slate-200",
  accounts: "bg-teal-100 text-teal-900 border-teal-300",
  auditor: "bg-rose-100 text-rose-900 border-rose-300",
};

export function RoleBadge({ role, className }) {
  if (!role) return null;
  return (
    <Badge
      variant="outline"
      data-testid={`role-badge-${String(role).replace(/_/g, "-")}`}
      className={cn("font-semibold border rounded-full px-2.5 py-0.5 text-[11px]", ROLE_STYLES[role] || "bg-stone-100 text-stone-700 border-stone-200", className)}
    >
      {ROLE_LABELS[role] || role}
    </Badge>
  );
}
